import React from 'react';

function MetroList(props) {
  const { children } = props;
  return <ul className="MetroList">{children}</ul>;
}

export default MetroList;
